import React from 'react';

export type ModalType<T> = React.FunctionComponent<{
  closeModal: () => void;
  isOpen: boolean;
  onRequestClose: () => void;
  customProps: T;
}>;

export type ModalContextType<T> = {
  openModal: (component: ModalType<T>, customProps?: T) => void;
};

export const ModalContext = React.createContext<ModalContextType<any>>({
  openModal: () => {},
});
